export default function HowItWorksSection() {
  const steps = [
    {
      number: "01",
      title: "Order Online in Minutes",
      description: "Complete your secure order at fastpassportcenter.com. Tell us your travel date and what service you need. Upload your current passport photo, proof of travel, and any supporting documents. Our system guides you through exactly what's needed — no guesswork.",
      icon: "ri-computer-line",
    },
    {
      number: "02",
      title: "Expert Document Review",
      description: "Our passport specialists review every document before your application leaves your hands. We check for errors, verify your photo meets State Department specs, confirm all required forms are complete, and flag anything that could cause a delay or rejection. This step alone saves weeks of back-and-forth that DIY applicants experience.",
      icon: "ri-file-search-line",
    },
    {
      number: "03",
      title: "Hand-Courier Submission",
      description: "Your application is professionally packaged and hand-delivered by our authorized courier to the U.S. passport agency — using one of our limited, State Department-allotted daily drop-off slots. These drop-off privileges are not available to the general public and each one guarantees processing within a specified number of days. Your application gets processed the same day it arrives at the agency. No mail queues. No lost envelopes. No waiting in line hoping for availability.",
      icon: "ri-mail-send-line",
    },
    {
      number: "04",
      title: "Overnight Return Delivery",
      description: "Your new passport ships back to you via overnight FedEx with real-time tracking. You'll get updates through your personal dashboard the entire way. Most customers receive their passport within 24 hours of agency release.",
      icon: "ri-plane-line",
    },
  ];

  return (
    <section id="how-it-works" className="bg-white py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">The Process</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            How <span className="text-[#F6C344]">Expedited Passport Service</span> Works
          </h2>
          <p className="text-gray-500 text-base max-w-2xl mx-auto">
            Four simple steps from order to delivery. Our registered couriers handle the hard part — you just provide the documents.
          </p>
        </div>

        <div className="space-y-0">
          {steps.map((step, i) => (
            <div key={i} className="relative flex flex-col md:flex-row gap-5 md:gap-8 pb-10 md:pb-14 last:pb-0">
              {i < steps.length - 1 && (
                <div className="hidden md:block absolute left-[39px] top-[72px] w-0.5 h-[calc(100%-24px)] bg-[#F6C344]/30"></div>
              )}
              <div className="flex-shrink-0 flex md:flex-col items-center md:items-start">
                <div className="w-20 h-20 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i className={`${step.icon} text-[#F6C344] text-2xl`}></i>
                </div>
                <div className="md:hidden ml-4 text-[#F6C344] text-xs font-bold">{step.number}</div>
              </div>
              <div className="flex-1 pt-1">
                <span className="hidden md:inline-block text-[#F6C344] text-xs font-bold uppercase tracking-[0.15em] mb-1">{`Step ${step.number}`}</span>
                <h3 className="font-serif text-xl md:text-2xl font-bold text-[#1A365D] mb-2">{step.title}</h3>
                <p className="text-gray-500 text-sm md:text-base leading-relaxed max-w-lg">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-7 py-3.5 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Start My Expedited Passport <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}